import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL } from './ter-protobomp-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje, _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';
import { ROUND, ROUNDDOWN, SQRT } from '../utils/excel-functions-utils';
import { MINUS, TAB_CHARACTER } from '../utils/frfr-string-consts';


export const derDraftel_terkk_npr_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_nrr.default_preset_state(),
    //
    tipkomore: virtel_k.tipkomore,
    vrstaprofila: virtel_k.vrstaprofila,
    duzinamodula: virtel_m.duzinamodula,
    // msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjupregradnih: virtel_m.mvisinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjukrilaca: virtel_m.mvisinaunutrasnjaizmedjukrilaca,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja,
  };
  return pods_input_inherited;
};


//
export const _derivat_terkk_npr_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let npr_materijal_lim_tanji = null;
  let npr_materijal_lim_deblji = null;
  if (tipmetalalima === "pocinkovani") {
    npr_materijal_lim_tanji = _cpci.npr_materijal_lim_pocinkovani_tanji;
    npr_materijal_lim_deblji = _cpci.npr_materijal_lim_pocinkovani_deblji;
  }
  if (tipmetalalima === "prohrom") {
    npr_materijal_lim_tanji = _cpci.npr_materijal_lim_prohrom_tanji;
    npr_materijal_lim_deblji = _cpci.npr_materijal_lim_prohrom_deblji;
  }
  const nprpostolje_materijal_profil = _cpci.nprpostolje_materijal_profil;
  const nprpostolje_materijal_lim = _cpci.nprpostolje_materijal_lim;
  //
  return {
    tipmetalalima,
    npr_materijal_lim_tanji,
    npr_materijal_lim_deblji,
    nprpostolje_materijal_profil,
    nprpostolje_materijal_lim,
  };
};


// izracunavanje sirina i visine na osnovu pods_input
export const _derivat_npr_izracunaj_prvo = (state, pods_input) => {
  //
  const {
    // msirinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjukrilaca,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    vrstaprofila,
    msirinaspoljasnja,
    mvisinaspoljasnja,
  } = pods_input;
  const {
    npr_tipkomore,
    npr_brojmodula,
  } = state;
  //
  const {
    unutrasnjaIzmedjuPregradnih: msirinaunutrasnjaizmedjupregradnih, // preimenujemo  u msirinaunutrasnjaizmedjupregradnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(msirinaspoljasnja, vrstaprofila);
  const {
    unutrasnjaIzmedjuPregradnih: mvisinaunutrasnjaizmedjupregradnih, // preimenujemo  u mvisinaunutrasnjaizmedjupregradnih
    unutrasnjaIzmedjuKrilaca: mvisinaunutrasnjaizmedjukrilaca, // preimenujemo  u mvisinaunutrasnjaizmedjukrilaca
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(mvisinaspoljasnja, vrstaprofila);
  //
  /*
  3.
  Širina komore = IF Tip komore="Spratna" OR Visina komore = IF Tip komore="Bok uz Bok" (-Ova vrednost se nasleđuje od komore i pretstavlja parametar $msirinaunutrasnjaizmedjupregradnih IF Tip komore= "Spratna" Else $mvisinaunutrasnjaizmedjupregradnih IF Tip komore= "Bok uz Bok"
  4.
  Preporučena "Visina donje sekcije"=IF Tip komore="Spratna" OR "Širina Prednje Sekcije"= IF Tip komore="Bok uz Bok"- Ova vrednost se nasleđuje od modula, parametar
  IF Tip komore="Spratna"  $mvisinaunutrasnjaizmedjukrilaca 
  IF Tip komore="Bok uz Bok"  $msirinaunutrasnjaizmedjupregradnih 
  8.
  Preporučena Visina gornje sekcije IF Tip komore="Spratna" OR Širina Zadnje Sekcije IF Tip komore="Bok uz Bok"- Nasleđuje se od modula, parametar:
  IF Tip komore="Spratna"  $mvisinaunutrasnjaizmedjukrilaca 
  IF Tip komore="Bok uz Bok"  $msirinaunutrasnjaizmedjupregradnih 
  */
  let npr_sirinakomore = null;
  let npr_visinadonjesekcije_preporucena = null;
  let npr_visinagornjesekcije_preporucena = null;
  if (npr_tipkomore === 'SPRATNA') {
    // npr_sirinakomore = msirinaunutrasnjaizmedjupregradnih;
    npr_sirinakomore = msirinaspoljasnja; // NJ 2025-03-18
    // npr_visinadonjesekcije_preporucena = mvisinaunutrasnjaizmedjukrilaca; //
    npr_visinadonjesekcije_preporucena = mvisinaspoljasnja; // NJ 2025-03-19: **
    console.log('npr_brojmodula', npr_brojmodula);
    if (npr_brojmodula === 2 || npr_brojmodula === "2") {
      // NJ 2025-03-18: Dopuna kod "Preporučena visina/sirina donje sekcije (spolj.)" ukoliko je $npr_brojmodula = 1 onda uzimamo vrednost mvisinaspoljasnja ili msirinaspoljasnja ako je $npr_brojmodula = 2 onda uzete vrednosti (mvisinaspoljasnja ili msirinaspoljasnja)/2
      npr_visinadonjesekcije_preporucena = ROUNDDOWN((npr_visinadonjesekcije_preporucena / 2), 0); // NJ 2025-03-18 Zaokružiti na 0 decimala sa ROUNDDOWN
    }
    npr_visinagornjesekcije_preporucena = npr_visinadonjesekcije_preporucena; //
  }
  let npr_visinakomore = null;
  let npr_sirinaprednjesekcije_preporucena = null;
  let npr_sirinazadnjesekcije_preporucena = null;
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    // npr_visinakomore = mvisinaunutrasnjaizmedjupregradnih;
    npr_visinakomore = mvisinaspoljasnja; // NJ 2025-03-18
    // npr_sirinaprednjesekcije_preporucena = msirinaunutrasnjaizmedjupregradnih;
    npr_sirinaprednjesekcije_preporucena = msirinaspoljasnja; // NJ 2025-03-18
    console.log('npr_brojmodula', npr_brojmodula);
    if (npr_brojmodula === 2 || npr_brojmodula === "2") {
      npr_sirinaprednjesekcije_preporucena = ROUNDDOWN((npr_sirinaprednjesekcije_preporucena / 2), 0); // NJ 2025-03-18 Zaokružiti na 0 decimala sa ROUNDDOWN
    }
    npr_sirinazadnjesekcije_preporucena = npr_sirinaprednjesekcije_preporucena; //
  }
  //
  return {
    npr_sirinakomore,
    npr_visinakomore,
    npr_visinadonjesekcije_preporucena,
    npr_visinagornjesekcije_preporucena,
    npr_sirinaprednjesekcije_preporucena,
    npr_sirinazadnjesekcije_preporucena,
  };
};


// izracunavanje za wiz step 2
export const _derivat_npr_izracunaj_bcdeh = (state, pods_input) => {
  //
  const {
    // msirinaunutrasnjaizmedjupregradnih,
    // mvisinaunutrasnjaizmedjupregradnih, // TODO
    // mvisinaunutrasnjaizmedjukrilaca,
    duzinamodula,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    vrstaprofila,
    // msirinaspoljasnja,
    // mvisinaspoljasnja,
  } = pods_input;
  const {
    npr_tipkomore,
    npr_brojmodula,
    npr_stranicarekuperatora,
    npr_sirinakomore,
    npr_visinadonjesekcije,
    npr_visinagornjesekcije,
    npr_visinakomore,
    npr_sirinaprednjesekcije,
    npr_sirinazadnjesekcije,
  } = state;
  //
  /*
  const {
    unutrasnjaIzmedjuPregradnih: msirinaunutrasnjaizmedjupregradnih, // preimenujemo  u msirinaunutrasnjaizmedjupregradnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(msirinaspoljasnja, vrstaprofila);
  const {
    unutrasnjaIzmedjuPregradnih: mvisinaunutrasnjaizmedjupregradnih, // preimenujemo  u mvisinaunutrasnjaizmedjupregradnih
    unutrasnjaIzmedjuKrilaca: mvisinaunutrasnjaizmedjukrilaca, // preimenujemo  u mvisinaunutrasnjaizmedjukrilaca
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(mvisinaspoljasnja, vrstaprofila);
  */
  //
  /*
  B=
  IF Tip komore "spratna" AND vrstaprofila = 50 THEN  $msirinaunutrasnjaizmedjupregradnih
  IF Tip komore "spratna" AND vrstaprofila = 70 THEN  $msirinaunutrasnjaizmedjupregradnih
  IF Tip komore "Bok uz Bok" AND vrstaprofila = 50 THEN  $mvisinaunutrasnjaizmedjukrilaca+40
  IF Tip komore "Bok uz Bok" AND vrstaprofila = 70 THEN  $mvisinaunutrasnjaizmedjukrilaca+70

  H1( odnosi se na visinu donje sekcije) =
  IF Tip komore "spratna" AND vrstaprofila = 50 THEN  $mvisinaunutrasnjaizmedjukrilaca + 90 /*
  IF Tip komore "spratna" AND vrstaprofila = 70 THEN  $mvisinaunutrasnjaizmedjukrilaca +125 /*
  IF Tip komore "Bok uz Bok" AND vrstaprofila = 50 THEN  $msirinaunutrasnjaizmedjupregradnih+50/*
  IF Tip komore "Bok uz Bok" AND vrstaprofila = 70 THEN  $msirinaunutrasnjaizmedjupregradnih+55/*

  H2 (odnosi se na visinu gornje sekcije)=
  IF Tip komore "spratna" AND vrstaprofila = 50 THEN  $mvisinaunutrasnjaizmedjukrilaca + 90 /*
  IF Tip komore "spratna" AND vrstaprofila = 70 THEN  $mvisinaunutrasnjaizmedjukrilaca +125 /*
  IF Tip komore "Bok uz Bok" AND vrstaprofila = 50 THEN  $msirinaunutrasnjaizmedjupregradnih+50 /*
  IF Tip komore "Bok uz Bok" AND vrstaprofila = 70 THEN  $msirinaunutrasnjaizmedjupregradnih+55 /*
  */
  const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(vrstaprofila);
  //
  let npr_b;
  let npr_h1;
  let npr_h2;
  /*
  if (npr_tipkomore === 'SPRATNA') {
    if (tervrstaprofila_50_ili_70 === '50') {
      npr_b = msirinaunutrasnjaizmedjupregradnih;
      npr_h1 = mvisinaunutrasnjaizmedjukrilaca + 90;
      npr_h2 = mvisinaunutrasnjaizmedjukrilaca + 90;
    }
    if (tervrstaprofila_50_ili_70 === '70') {
      npr_b = msirinaunutrasnjaizmedjupregradnih;
      npr_h1 = mvisinaunutrasnjaizmedjukrilaca + 125;
      npr_h2 = mvisinaunutrasnjaizmedjukrilaca + 125;
    }
  }
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    if (tervrstaprofila_50_ili_70 === '50') {
      npr_b = mvisinaunutrasnjaizmedjukrilaca + 40;
      npr_h1 = msirinaunutrasnjaizmedjupregradnih + 50;
      npr_h2 = msirinaunutrasnjaizmedjupregradnih + 50;
    }
    if (tervrstaprofila_50_ili_70 === '70') {
      npr_b = mvisinaunutrasnjaizmedjukrilaca + 70;
      npr_h1 = msirinaunutrasnjaizmedjupregradnih + 55;
      npr_h2 = msirinaunutrasnjaizmedjupregradnih + 55;
    }
  }
  */
  // NJ 2025-03-20: Nove formule su;
  if (npr_tipkomore === 'SPRATNA') {
    if (tervrstaprofila_50_ili_70 === '50') {
      npr_b = npr_sirinakomore - 102;
      npr_h1 = npr_visinadonjesekcije - 50;
      npr_h2 = npr_visinagornjesekcije - 50;
    }
    if (tervrstaprofila_50_ili_70 === '70') {
      npr_b = npr_sirinakomore - 112;
      npr_h1 = npr_visinadonjesekcije - 55;
      npr_h2 = npr_visinagornjesekcije - 55;
    }
  }
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    if (tervrstaprofila_50_ili_70 === '50') {
      npr_b = npr_visinakomore - 102;
      npr_h1 = npr_sirinaprednjesekcije - 50;
      npr_h2 = npr_sirinazadnjesekcije - 50;
    }
    if (tervrstaprofila_50_ili_70 === '70') {
      npr_b = npr_visinakomore - 112;
      npr_h1 = npr_sirinaprednjesekcije - 55;
      npr_h2 = npr_sirinazadnjesekcije - 55;
    }
  }
  let npr_b1;
  /*
  IF  Tip komore "spratna" THEN
  IF $brojmodula =2 AND Profil = P70  THEN B-30 ELSE B
  ELSE IF Tip komore "Bok uz Bok" THEN
  IF $brojmodula =2 AND Profil = P70  THEN B-50 ELSE B /* 2510 izmenjena je logika za B1
  */
  if (npr_tipkomore === 'SPRATNA') {
    if ((npr_brojmodula === 2 || npr_brojmodula === "2") && tervrstaprofila_50_ili_70 === '70') {
      npr_b1 = npr_b - 30;
    } else {
      npr_b1 = npr_b;
    }
  }
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    if ((npr_brojmodula === 2 || npr_brojmodula === "2") && tervrstaprofila_50_ili_70 === '70') {
      npr_b1 = npr_b - 80; // 04.12. izmenjeno je umesto -50 na -80  /2510 izmenjena je logika za B1 
    } else {
      npr_b1 = npr_b;
    }
  }
  const npr_h = npr_h1 + npr_h2; // H= H1+H2
  /*
  C=
  IF Tip komore "spratna" THEN ROUND(2)(H1-(SQRT(2)*$Stranicarekuperatora)/2)+0,9
  ELSE
  IF Tip komore "Bok uz bok" THEN ROUND(2)(H1-(SQRT(2)*$Stranicarekuperatora)/2)-10
  */
  let npr_c;
  if (npr_tipkomore === 'SPRATNA') {
    npr_c = ROUND(((npr_h1 - (SQRT(2) * npr_stranicarekuperatora) / 2) + 0.9), 2);
  }
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    npr_c = ROUND(((npr_h1 - (SQRT(2) * npr_stranicarekuperatora) / 2) - 10), 2);
  }
  /*
  L=
  IF vrstaprofila = 50 THEN $duzinamodula -100
  ELSE
  IF vrstaprofila = 70 AND $brojmodula =1 THEN $duzinamodula -110
  ELSE
  IF vrstaprofila = 70 AND $brojmodula =2 THEN $duzinamodula -140
  */
  // const npr_l = mduzinaunutrasnjaizmedjupregradnih;
  let npr_l;
  if (tervrstaprofila_50_ili_70 === '50') {
    npr_l = duzinamodula - 100;
  } else if (tervrstaprofila_50_ili_70 === '70') {
    if (npr_brojmodula === 1 || npr_brojmodula === "1") {
      npr_l = duzinamodula - 110;
    } else if (npr_brojmodula === 2 || npr_brojmodula === "2") {
      npr_l = duzinamodula - 140;
    }
  }
  /*
  D=
  IF Tip komore "spratna" THEN ROUND(2)(L-(SQRT(2)*$Stranicarekuperatora)/2)+0,6  /*
  ELSE
  IF Tip komore "Bok uz bok" THEN ROUND(2)(L-(SQRT(2)*$Stranicarekuperatora)/2)-10 /*
  */
  let npr_d;
  if (npr_tipkomore === 'SPRATNA') {
    // npr_d = ROUND(((npr_l - (SQRT(2) * npr_stranicarekuperatora) / 2) + 0.6), 2);
    // NJ: npr_d = ROUND(((npr_l - SQRT(2) * npr_stranicarekuperatora) / 2) - 0.6, 2);
    npr_d = ROUND(((npr_l - SQRT(2) * npr_stranicarekuperatora) / 2) - 0.6, 2);
  }
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    // npr_d = ROUND(((npr_l - (SQRT(2) * npr_stranicarekuperatora) / 2) - 10), 2);
    // NJ: npr_d = ROUND(((npr_l - SQRT(2) * npr_stranicarekuperatora) / 2) - 10, 2);
    npr_d = ROUND(((npr_l - SQRT(2) * npr_stranicarekuperatora) / 2) - 10, 2);
  }
  /*
  E=
  IF Tip komore "spratna" THEN ROUND(2)(H2-(SQRT(2)*$Stranicarekuperatora)/2)-2
  ELSE
  IF Tip komore "Bok uz bok" THEN C
  NOTE: ROUND(2) označava da se zaokružuje na dve decimale.
  */
  let npr_e;
  if (npr_tipkomore === 'SPRATNA') {
    npr_e = ROUND(((npr_h2 - (SQRT(2) * npr_stranicarekuperatora) / 2) - 2), 2);
  }
  if (npr_tipkomore === 'BOK_UZ_BOK') {
    npr_e = npr_c;
  }
  //
  return {
    npr_b: ROUND(npr_b, 2),
    npr_b1: ROUND(npr_b1, 2),
    npr_h: ROUND(npr_h, 2),
    npr_h1: ROUND(npr_h1, 2),
    npr_h2: ROUND(npr_h2, 2),
    npr_c: ROUND(npr_c, 2),
    npr_d: ROUND(npr_d, 2),
    npr_e: ROUND(npr_e, 2),
    //
    npr_l: ROUND(npr_l, 2),
    //
    tervrstaprofila_50_ili_70,
  };
};


//
export const _derivat_terkk_npr_solidworks_export_string_make = (state) => {
  const {
    npr_b,
    npr_b1,
    npr_h,
    npr_h1,
    npr_h2,
    npr_stranicarekuperatora,
    npr_c,
    npr_d,
    npr_e,
    npr_l,
    //
    npr_tipkomore,
    npr_brojmodula,
    tervrstaprofila_50_ili_70,
  } = state;
  const npr_a = npr_stranicarekuperatora; // NJ: Parametar A ti nisam do sada slao, on ima vrednost polja $npr_stranicarekuperatora
  //
  let ident = '?';
  const item = {};
  if (npr_tipkomore === "SPRATNA") {
    // IF Tip komore "Spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50 /*
    item.npr_tip_ab = 'A';
    ident = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_h1 + npr_h2 + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70;
  } else if (npr_tipkomore === "BOK_UZ_BOK") {
    // IF Tip komore "Bok uz bok" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50 /*
    item.npr_tip_ab = 'B';
    ident = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_h1 + npr_h2 + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70;
  }
  //
  //
  const arr_to_export = [
    ident,
    npr_b,
    npr_b1,
    npr_h,
    npr_h1,
    npr_h2,
    npr_a,
    npr_c,
    npr_d,
    npr_e,
    npr_l
  ];
  const string_to_export = arr_to_export.join(TAB_CHARACTER);
  return string_to_export;
};


//
export const _derivat_terkk_npr_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 

  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    npr_materijal_lim_tanji,
    npr_materijal_lim_deblji,
    nprpostolje_materijal_profil,
    nprpostolje_materijal_lim,
    npr_sirinakomore,
    npr_visinakomore,
    npr_visinadonjesekcije,
    npr_visinagornjesekcije,
    npr_sirinaprednjesekcije,
    npr_sirinazadnjesekcije,
    //
    npr_b,
    npr_b1,
    npr_h,
    npr_h1,
    npr_h2,
    npr_c,
    npr_d,
    npr_e,
    //
    npr_l,
    //
    tervrstaprofila_50_ili_70,
    duzinamodula,
    //
    npr_tipkomore,
    npr_brojmodula,
    npr_stranicarekuperatora,
    npr_demperbypass,
  } = protobomp_superdata;
  //

  //
  if (true) {
    // sklop
    if (family === 'terkk$npr/SKLOP_NPR') { // 1. Odnosi se na sklop nosača
      // Naziv: "NOSAC PLOCASTOG REKUPERATORA R:" $sirinaRekuperatora"X"$stranicarekuperatora" K"$Brojmodula":"$sirinakomore"X"$duzinasekcije
      // Naziv: "NOSAC PLOCASTOG REKUPERATORA R: "$stranicarekuperatora" K"$Brojmodula":"$sirinakomore"X"$duzinasekcije */ 29.10 promena: Izbacujemo $sirinarekuperatora koristi se samo $Stranicarekuperatora. Umesto dužina sekcije promenjeno je u $duzinamodula
      item.distinction_key = "terkk$NPR/SKLOP_NPR"; // DIRTY
      js_utils.dirty_enrich_object_with_obj2_shallow(item, {
        tervrstaprofila_50_ili_70,
        duzinamodula,
        npr_tipkomore,
        npr_brojmodula,
        npr_stranicarekuperatora,
        npr_demperbypass,
      });
      if (npr_tipkomore === "SPRATNA") {
        item.tip = "A"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA R:" + npr_stranicarekuperatora + " K" + npr_brojmodula + ":" + npr_sirinakomore + "x" + duzinamodula;
        item.npr_sirinakomore = npr_sirinakomore; // DIRTY
        item.npr_visinadonjesekcije = npr_visinadonjesekcije; // DIRTY
        item.npr_visinagornjesekcije = npr_visinagornjesekcije; // DIRTY
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.tip = "B"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA R:" + npr_stranicarekuperatora + " K" + npr_brojmodula + ":" + npr_visinakomore + "x" + duzinamodula;
        item.npr_visinakomore = npr_visinakomore; // DIRTY
        item.npr_sirinaprednjesekcije = npr_sirinaprednjesekcije; // DIRTY
        item.npr_sirinazadnjesekcije = npr_sirinazadnjesekcije; // DIRTY
      }
      item.kolicina = 1; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSKL"; // DIRTY
      item.rc1 = "GRCFIN"; // DIRTY
    }
    // sklop
    if (family === 'terkk$nprpostolje/SKLOP_NPR_POSTOLJE') { // 1. Odnosi se na sklop nosača
      item.distinction_key = "terkk$NPR/SKLOP_NPR_POSTOLJE"; // DIRTY
      item.tip = "B-P4"; // DIRTY
      // Naziv: "POSTOLJE PLOCASTOG REKUPERATORA" $stranicarekuperatora "-P4"
      _naziv = "POSTOLJE PLOCASTOG REKUPERATORA" + npr_stranicarekuperatora + "-P4";
      // Količina: 2*$količina
      item.jm = tclocal.JM_KOM; // DIRTY
      item.operacija1 = "OPSKL"; // DIRTY
      item.rc1 = "RCZAV"; // DIRTY
    }
    //
    //
    if (family === 'terkk$npr/A_P1_B_P1') { // 2. P1
      if (npr_tipkomore === "SPRATNA") {
        item.distinction_key = "terkk$NPR/A_P1"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P1 - DONJI";
        item.tip = "A-P1"; // DIRTY
        item.npr_tip_ab = 'A'; // DIRTY
        item.dimenzija1 = npr_b;
        item.dimenzija2 = npr_c;
        item.razvijenamera1 = npr_b + 44.8;
        item.razvijenamera2 = npr_c + 47.7;
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_visinadonjesekcije + npr_visinagornjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P1";
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.distinction_key = "terkk$NPR/B_P1"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P1";
        item.tip = "B-P1"; // DIRTY
        item.npr_tip_ab = 'B'; // DIRTY
        item.dimenzija1 = npr_b;
        item.dimenzija2 = npr_c;
        item.razvijenamera1 = npr_b + 41.1;
        item.razvijenamera2 = npr_c + 20.6;
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P1";
      }
      item.kolicina = 2; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      // "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P1"
    }

    // 
    if (family === 'terkk$npr/A_P2_B_P11') { // 3. P2
      if (npr_tipkomore === "SPRATNA") {
        item.distinction_key = "terkk$NPR/A_P2"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P2 - BOCNI";
        item.tip = "A-P2"; // DIRTY
        item.npr_tip_ab = 'A'; // DIRTY
        item.dimenzija1 = npr_b1;
        item.dimenzija2 = npr_d;
        item.razvijenamera1 = npr_b1 + 44.8;
        item.razvijenamera2 = npr_d + 41.7;
        // IF Tip komore "spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P2"
        // "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"$npr_visinadonjesekcije$npr_visinagornjesekcije"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P1" /**** 11.12.2024Promena je umesto H1&H2 koristimo parametre $npr_visinadonjesekcije$npr_visinagornjesekcije
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_visinadonjesekcije + npr_visinagornjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P2";
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.distinction_key = "terkk$NPR/B_P1.1"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P1.1";
        item.tip = "B-P1.1"; // DIRTY
        item.npr_tip_ab = 'B'; // DIRTY
        item.dimenzija1 = npr_b - 5;
        item.dimenzija2 = 49.6;
        item.razvijenamera1 = npr_b - 5;
        item.razvijenamera2 = 69.2;
        // IF Tip komore "spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B & brojmodula"-"B"-"H1 & H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P1.1"
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P1.1";
      }
      item.kolicina = 4; // DIRTY
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }

    // 
    if (family === 'terkk$npr/A_P3_B_P2') { // 4. P3
      if (npr_tipkomore === "SPRATNA") {
        item.distinction_key = "terkk$NPR/A_P3"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P3 - GORNJI";
        item.kolicina = 1; // DIRTY
        item.tip = "A-P3"; // DIRTY
        item.npr_tip_ab = 'A'; // DIRTY
        item.dimenzija1 = npr_b;
        item.dimenzija2 = npr_e;
        item.razvijenamera1 = npr_b + 44.8;
        item.razvijenamera2 = npr_e + 22.4;
        // IF Tip komore "spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P3"
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_visinadonjesekcije + npr_visinagornjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P3";
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.distinction_key = "terkk$NPR/B_P2"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P2";
        item.kolicina = 2; // DIRTY
        item.tip = "B-P2"; // DIRTY
        item.npr_tip_ab = 'B'; // DIRTY
        item.dimenzija1 = npr_b1;
        item.dimenzija2 = npr_d;
        item.razvijenamera1 = npr_b1 + 41.1;
        item.razvijenamera2 = npr_d + 20.6;
        // IF Tip komore "Bok uz bok" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P2"
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P2";
      }
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }

    // 
    if (family === 'terkk$npr/A_P4_B_P21') { // 5. P4
      if (npr_tipkomore === "SPRATNA") {
        item.distinction_key = "terkk$NPR/A_P4"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P4 - STELUJUCI";
        // item.kolicina = 1; // DIRTY
        item.kolicina = 2; // DIRTY // NJ 2025-02-28; Broj komada: IF Tip komore "Spratna" THEN 1 //28.02.2025 potrebno je ppromeniti u 2 "THEN 1"
        item.tip = "A-P4"; // DIRTY
        item.npr_tip_ab = 'A'; // DIRTY
        item.dimenzija1 = npr_b;
        item.dimenzija2 = npr_e;
        item.razvijenamera1 = npr_b1 + 44.8;
        item.razvijenamera2 = npr_e + 22.4;
        // IF Tip komore "Spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P4"
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_visinadonjesekcije + npr_visinagornjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P4";
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.distinction_key = "terkk$NPR/B_P2.1"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P2.1";
        item.kolicina = 4; // DIRTY
        item.tip = "B-P2.1"; // DIRTY
        item.npr_tip_ab = 'B'; // DIRTY
        item.dimenzija1 = npr_b1;
        item.dimenzija2 = npr_d;
        item.razvijenamera1 = npr_b1 + 41.1;
        item.razvijenamera2 = npr_d + 20.6;
        // IF Tip komore "Bok uz bok" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P2.1" /*
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P2.1";
      }
      item.dimenzija1 = npr_b - 5;
      item.dimenzija2 = 68.8;
      item.razvijenamera1 = npr_b - 5;
      item.razvijenamera2 = 89.2;
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }

    // NOVO ovaj izbaciti
    /*
    if (family === 'terkk$npr/A_P5_B_P3') { // 6. P5
      item.kolicina = -1; // DIRTY
      if (npr_tipkomore === "SPRATNA") {
        item.distinction_key = "terkk$NPR/A_P5"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P5 - OPSIVKE";
        item.tip = "A-P5"; // DIRTY
        item.npr_tip_ab = 'A'; // DIRTY
        item.dimenzija1 = npr_stranicarekuperatora - 2;
        if (npr_brojmodula === 1) {
          item.dimenzija2 = 60;
          item.razvijenamera2 = 60;
          item.kolicina = 4; // DIRTY
        } else if (npr_brojmodula === 2) {
          item.dimenzija2 = 40;
          item.razvijenamera2 = 40;
          if (npr_demperbypass === "DA") {
            item.kolicina = 6; // DIRTY
          } else if (npr_demperbypass === "NE") {
            item.kolicina = 8; // DIRTY
          }
        }
        item.razvijenamera1 = npr_stranicarekuperatora - 2;
        // item.identmaterijala = npr_materijal_lim_tanji; // DIRTY
        // IF Tip komore "spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P5"
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_visinadonjesekcije + npr_visinagornjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P5";
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.distinction_key = "terkk$NPR/B_P3"; // DIRTY
        _naziv = "NOSAC PLOCASTOG REKUPERATORA - P3";
        item.tip = "B-P3"; // DIRTY
        item.npr_tip_ab = 'B'; // DIRTY
        item.kolicina = 2; // NJ: ### (OVO MORAM DA PROVERIM)
        item.dimenzija1 = npr_l;
        item.dimenzija2 = 102;
        item.razvijenamera1 = npr_l;
        item.razvijenamera2 = 147;
        if (npr_l > 2500) { // NJ 2024-12-04: izmena 04.12- ovaj deo može da bude iz dva dela logika: IF $L>2500 THEN 4 ELSE 2
          item.kolicina = 4; //
          item.dimenzija1 = ROUNDDOWN(npr_l / 2, 0);
          item.razvijenamera1 = ROUNDDOWN(npr_l / 2, 0);
        }
        // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
        // IF Tip komore "Bok uz bok" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P3"
        _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P3";
      }
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }
    */
    //
    if (family === 'terkk$npr/A_P5') { // 6. P5
      item.kolicina = -1; // DIRTY
      // if (npr_tipkomore === "SPRATNA") {
      item.distinction_key = "terkk$NPR/A_P5"; // DIRTY
      _naziv = "NOSAC PLOCASTOG REKUPERATORA - P5 - OPSIVKE";
      item.tip = "A-P5"; // DIRTY
      item.npr_tip_ab = 'A'; // DIRTY
      item.dimenzija1 = npr_stranicarekuperatora - 2;
      if (npr_brojmodula === 1) {
        item.dimenzija2 = 60;
        item.razvijenamera2 = 60;
        item.kolicina = 4; // DIRTY
      } else if (npr_brojmodula === 2) {
        item.dimenzija2 = 40;
        item.razvijenamera2 = 40;
        if (npr_demperbypass === "DA") {
          item.kolicina = 6; // DIRTY
        } else if (npr_demperbypass === "NE") {
          item.kolicina = 8; // DIRTY
        }
      }
      item.razvijenamera1 = npr_stranicarekuperatora - 2;
      // item.identmaterijala = npr_materijal_lim_tanji; // DIRTY
      // IF Tip komore "spratna" THEN "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P5"
      _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_visinadonjesekcije + npr_visinagornjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P5";
      // }
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }
    //
    if (family === 'terkk$npr/B_P31') { // NOVO B3.1
      /*
      Naziv
      IF Tip komore "Bok uz Bok" AND $npr_brojmodula=2 THEN "NOSAC PLOCASTOG REKUPERATORA -P3.1" ELSE null
      Broj komada: IF npr_l >2500 THEN 2 ELSE 1
      Dužina:
      IF npr_l >2500 THEN npr_l ELSE npr_l/2
      Dim. 2
      102
      Razvijena 1
      IF npr_l >2500 THEN npr_l ELSE npr_l/2
      Razvijena 2
      147
      */
      item.kolicina = -1; // DIRTY
      // if (npr_tipkomore === "SPRATNA") {
      // } else if (npr_tipkomore === "BOK_UZ_BOK") {
      item.distinction_key = "terkk$NPR/B_P3.1"; // DIRTY
      _naziv = "NOSAC PLOCASTOG REKUPERATORA - P3.1";
      item.tip = "B-P3.1"; // DIRTY
      item.npr_tip_ab = 'B'; // DIRTY
      item.kolicina = 1; //
      item.dimenzija1 = npr_l;
      item.dimenzija2 = 102;
      item.razvijenamera1 = npr_l;
      item.razvijenamera2 = 147;
      if (npr_l > 2500) { //
        item.kolicina = 2; //
        item.dimenzija1 = ROUNDDOWN(npr_l / 2, 0);
        item.razvijenamera1 = ROUNDDOWN(npr_l / 2, 0);
      }
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      // CNC crtež: "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P3.1"
      _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P3.1";
      // }
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }
    //
    if (family === 'terkk$npr/B_P32') { // NOVO B3.2
      /*
      Naziv
      IF Tip komore "Bok uz Bok" AND $npr_brojmodula=2 THEN "NOSAC PLOCASTOG REKUPERATORA -P3.2" ELSE null
      Broj komada: IF npr_l >2500 THEN 2 ELSE 1
      Dužina:
      IF npr_l >2500 THEN npr_l ELSE npr_l/2
      Dim. 2
      102
      Razvijena 1
      IF npr_l >2500 THEN npr_l ELSE npr_l/2
      Razvijena 2
      127
      */
      item.kolicina = -1; // DIRTY
      // if (npr_tipkomore === "SPRATNA") {
      // } else if (npr_tipkomore === "BOK_UZ_BOK") {
      item.distinction_key = "terkk$NPR/B_P3.2"; // DIRTY
      _naziv = "NOSAC PLOCASTOG REKUPERATORA - P3.2";
      item.tip = "B-P3.2"; // DIRTY
      item.npr_tip_ab = 'B'; // DIRTY
      item.kolicina = 1; // NJ: ### (OVO MORAM DA PROVERIM)
      item.dimenzija1 = npr_l;
      item.dimenzija2 = 102;
      item.razvijenamera1 = npr_l;
      item.razvijenamera2 = 127; //
      if (npr_l > 2500) { //
        item.kolicina = 2; //
        item.dimenzija1 = ROUNDDOWN(npr_l / 2, 0);
        item.razvijenamera1 = ROUNDDOWN(npr_l / 2, 0);
      }
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      // CNC crtež: "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P3.1"
      _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P3.2";
      // }
      item.jm = tclocal.JM_KOM; // DIRTY
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
    }

    //
    const _duzina_profila_p41 = npr_stranicarekuperatora - 78; // $duzinaprofilaP4.1= $stranicarekuperatora-78
    // $duzinaprofilaP4.2= (SQRT(2*$duzinaprofilaP4.1^2))-113
    const _duzina_profila_p42 = ROUNDDOWN((SQRT(2 * (_duzina_profila_p41 * _duzina_profila_p41))) - 113); //

    //
    if (family === 'terkk$npr/B_P5') { // 4. Odnosi se na element P5 sklopa nosača pločastog rekuperatora
      /*
      Naziv: "NOSAC PLOCASTOG REKUPERATORA - P5-POKLOPAC"
      Količina: 2kom
      Dim1: $duzinaprofilaP4.1
      Dim 2:$duzinaprofilaP4.2+113
      Površina: ($duzinaprofilaP4.1^2)/2
      razvijena 1: $duzinaprofilaP4.1
      Razvijena 2: $duzinaprofilaP4.2+113
      CNC crtež:
      "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P5" /*
      Operacija 1: Sečenje
      Radni centar:RC Amada
      Operacija 2:null
      Ident materijlaa: LC00000D
      */
      item.distinction_key = "terkk$NPR/B_P5"; // DIRTY
      item.kolicina = 2; // DIRTY
      item.dimenzija1 = _duzina_profila_p41; // DIRTY
      item.dimenzija2 = _duzina_profila_p42 + 113; // DIRTY
      item.razvijenamera1 = _duzina_profila_p41;
      item.razvijenamera2 = _duzina_profila_p42 + 113;
      povrsina = ((_duzina_profila_p41 * _duzina_profila_p41) / 2);
      _naziv = "NOSAC PLOCASTOG REKUPERATORA - P5-POKLOPAC";
      // item.identmaterijala = nprpostolje_materijal_lim; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.tip = "B-P5"; // DIRTY
      if (npr_tipkomore === "SPRATNA") {
        item.npr_tip_ab = 'A'; // TODO VEROVATNO NE TREBA
      } else if (npr_tipkomore === "BOK_UZ_BOK") {
        item.npr_tip_ab = 'B';
      }
      // "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P5"
      _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P5";
    }

    //
    if (family === 'terkk$npr/B_P6') { // P6
      /*
      Odnosi se na element sklopa
      Naziv: "NOSAC PLOCASTOG REKUPERATORA - P6-OPSIVKE"
      Broj komada: 4
      Dužina:
      $StranicaRekuperatora
      Dim. 2
      IF &brojmodula = 1 THEN 130 ELSE
      &brojmodula =2 THEN 90
      Razvijena 1
      $StranicaRekuperatora
      Razvijena 2
      IF &brojmodula = 1 THEN 160 ELSE
      &brojmodula =2 THEN 120
      CNC crtež:
      "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P6"
      Operacija 1:
      Op-Secenje
      Radni centar 1:
      RC-Probijacica Amada
      Operacija 2:
      Op-Savijanje
      Radni centar 2:
      RC-Presa Ermaksan
      Materijal:
      IF Tip komore "HYGIENE:pro" THEN LC00000J-LIM PROHROM 1.5
      ELSE LB00000J-LIM POCINKOVANI 1.5
      */
      item.distinction_key = "terkk$NPR/B_P6"; // DIRTY
      _naziv = "NOSAC PLOCASTOG REKUPERATORA - P6-OPSIVKE";
      item.tip = "B-P6"; // DIRTY
      item.npr_tip_ab = 'B'; // DIRTY
      item.kolicina = 4;
      item.dimenzija1 = npr_stranicarekuperatora;
      if (npr_brojmodula === 1) {
        item.dimenzija2 = 160;
      } else if (npr_brojmodula === 2) {
        item.dimenzija2 = 90;
      }
      item.razvijenamera1 = npr_stranicarekuperatora;
      if (npr_brojmodula === 1) {
        item.razvijenamera2 = 160;
      } else if (npr_brojmodula === 2) {
        item.razvijenamera2 = 120;
      }
      povrsina = item.razvijenamera1 * item.razvijenamera2;
      // item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCPRBAM"; // DIRTY
      item.operacija2 = "OPSAV"; // DIRTY
      item.rc2 = "RCPRSER"; // DIRTY
      // CNC crtež: "P01-13-" IF Tip komore "spratna" THEN A IF Tip komore "Bok uz bok" THEN B &brojmodula"-"B"-"H1&H2"-"$L$Stranicarekuperatora"-"IF profil P70 then 70 ELSE P50 then 50"-P6"
      _cnc = "P01-13-" + item.npr_tip_ab + npr_brojmodula + MINUS + npr_b + MINUS + npr_sirinaprednjesekcije + npr_sirinazadnjesekcije + MINUS + npr_l + npr_stranicarekuperatora + MINUS + tervrstaprofila_50_ili_70 + "-P6";
    }

    //
    //
    if (family === 'terkk$nprpostolje/B_P41') { // 2. Odnosi se na element P4.1 sklopa postolja rekuperatora
      /*
      $duzinaprofilaP4.1= $stranicarekuperatora-78
      Naziv: "POSTOLJE PLOCASTOG REKUPERATORA" $duzinaprofilaP4.1 "-P4.1"
      Količina: 2kom
      Dužina: $duzinaprofilaP4.1
      Levi ger: 45
      Desni ger: 45
      Operacija 1: Sečenje
      Radni centar:RC zavarivanje
      Ident materijlaa: P4040EA000C06000
      */
      item.distinction_key = "terkk$NPR/B_P4.1"; // DIRTY
      item.tip = "B-P4.1"; // DIRTY
      item.kolicina = 2; // DIRTY
      item.duzina = _duzina_profila_p41; // DIRTY
      _naziv = "POSTOLJE PLOCASTOG REKUPERATORA " + item.duzina + "-P4.1"
      item.leviger = 45; // DIRTY
      item.desniger = 45; // DIRTY
      // item.identmaterijala = nprpostolje_materijal_profil; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCZAV"; // DIRTY
    }
    //
    if (family === 'terkk$nprpostolje/B_P42') { // 3. Odnosi se na element P4.2 sklopa postolja rekuperatora
      /*
      $duzinaprofilaP4.2= (SQRT(2*$duzinaprofilaP4.1^2))-113
      Naziv: "POSTOLJE PLOCASTOG REKUPERATORA" $duzinaprofilaP4.2"-P4.2"
      Količina: 1kom
      Dužina: $duzinaprofilaP4.2
      Levi ger: 45
      Desni ger: 45
      Operacija 1: Sečenje
      Radni centar:RC zavarivanje
      Ident materijlaa: P4040EA000C06000
      */
      item.distinction_key = "terkk$NPR/B_P4.2"; // DIRTY
      item.tip = "B-P4.2"; // DIRTY
      item.kolicina = 1; // DIRTY // Količina za 4.2 treba da bude 1.
      item.duzina = _duzina_profila_p42; // DIRTY
      _naziv = "POSTOLJE PLOCASTOG REKUPERATORA " + item.duzina + "-P4.2"
      item.leviger = 45; // DIRTY
      item.desniger = 45; // DIRTY
      // item.identmaterijala = nprpostolje_materijal_profil; // DIRTY
      item.operacija1 = "OPSEC"; // DIRTY
      item.rc1 = "RCZAV"; // DIRTY
    }

    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_npr_izracunaj_za_step_protobomp = (state, pods_input) => {
  console.log('_derivat_terkk_npr_izracunaj_za_step_protobomp state', state);
  //
  const {
    duzinamodula,
  } = pods_input;
  const {
    npr_materijal_lim_tanji,
    npr_materijal_lim_deblji,
    nprpostolje_materijal_profil,
    nprpostolje_materijal_lim,
    npr_sirinakomore,
    npr_visinakomore,
    npr_visinadonjesekcije,
    npr_visinagornjesekcije,
    npr_sirinaprednjesekcije,
    npr_sirinazadnjesekcije,
    //
    npr_b,
    npr_b1,
    npr_h,
    npr_h1,
    npr_h2,
    npr_c,
    npr_d,
    npr_e,
    //
    npr_l,
    //
    tervrstaprofila_50_ili_70,
    //
    npr_tipkomore,
    npr_brojmodula,
    npr_stranicarekuperatora,
    npr_demperbypass,
    //
    kolicina,
  } = state;
  //

  // TODO
  const protobomp_superdata = {
    npr_materijal_lim_tanji,
    npr_materijal_lim_deblji,
    nprpostolje_materijal_profil,
    nprpostolje_materijal_lim,
    npr_sirinakomore,
    npr_visinakomore,
    npr_visinadonjesekcije,
    npr_visinagornjesekcije,
    npr_sirinaprednjesekcije,
    npr_sirinazadnjesekcije,
    //
    npr_b,
    npr_b1,
    npr_h,
    npr_h1,
    npr_h2,
    npr_c,
    npr_d,
    npr_e,
    //
    npr_l,
    //
    tervrstaprofila_50_ili_70,
    duzinamodula,
    //
    npr_tipkomore,
    npr_brojmodula,
    npr_stranicarekuperatora,
    npr_demperbypass,
  };

  //
  // 
  // let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$npr"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_npr_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  _temp_sklop = {
    ..._sklop_uzor,
    pbnode_family: 'terkk$npr/SKLOP_NPR',
    naziv: '* SKLOP NPR',
    kolicina: 1, // TODO
  };
  _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata);
  _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_NPR');
  const { created_tempkey: sklop_npr } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
  //
  //
  // ----- dodavanje primitivnih u sklopove
  //
  if (true) {
    // something
    if (true) { // 2. P1
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/A_P1_B_P1',
      };
      item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }
    //
    if (true) { // 3. P2
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/A_P2_B_P11',
      };
      item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }
    //
    if (true) { // 4. P3
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/A_P3_B_P2',
      };
      item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }
    //
    if (true) { // 5. P4
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/A_P4_B_P21',
      };
      item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }
    //

    /*
    if (true) { // 5. P5 // NOVO ovaj izbacujemo ali tu je privremeno
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/A_P5_B_P3',
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }
    */
    //
    if (npr_tipkomore === 'SPRATNA') {// NOVO
      if (true) { // NOVO A P5
        const item = {
          tempkey: 1,
          pbnode_family: 'terkk$npr/A_P5',
        };
        item.identmaterijala = npr_materijal_lim_tanji; // DIRTY
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
      }
    }
    //
    if (npr_tipkomore === 'BOK_UZ_BOK' && npr_brojmodula === 2) { // NJ 2024-12-20: novo B3.1 i B3.2 umesto B3
      //
      if (true) { // NOVO B3.1
        const item = {
          tempkey: 1,
          pbnode_family: 'terkk$npr/B_P31',
        };
        item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
      }
      //
      if (true) { // NOVO B3.2
        const item = {
          tempkey: 1,
          pbnode_family: 'terkk$npr/B_P32',
        };
        item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
      }
    }

    //
    if (npr_tipkomore === 'BOK_UZ_BOK' && npr_brojmodula === 2) {
      //
      // ovaj ide u prvi sklop
      if (true) { // 4. Odnosi se na element P5 sklopa nosača pločastog rekuperatora
        const item = {
          tempkey: 1,
          pbnode_family: 'terkk$npr/B_P5',
        };
        item.identmaterijala = nprpostolje_materijal_lim; // DIRTY
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
      }
    }

    //
    if (npr_tipkomore === 'BOK_UZ_BOK') { // P6 // NJ 2024-12-12: Potrebno je dodati još jedan element kod "Bok uz Bok" Radi se o opšivkama za Bok uz Bok tip komore, pa u uslovima neću stavljati spratnu komoru.
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/B_P6',
      };
      item.identmaterijala = npr_materijal_lim_deblji; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }
    //

  }
  //
  // dodatni sklop postolje
  if (npr_tipkomore === 'BOK_UZ_BOK' && npr_brojmodula === 2) {
    //
    // ovaj ide u prvi sklop
    if (true) { // 4. Odnosi se na element P5 sklopa nosača pločastog rekuperatora
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$npr/B_P5',
      };
      item.identmaterijala = nprpostolje_materijal_lim; // DIRTY
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_npr);
    }

    // ----- sklop drugi
    _temp_sklop = {
      ..._sklop_uzor,
      pbnode_family: 'terkk$nprpostolje/SKLOP_NPR_POSTOLJE',
      naziv: '* SKLOP POSTOLJE PLOCASTOG REKUPERATORA',
      kolicina: (2 * kolicina), // // Količina: 2*$količina
    };
    _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata);
    _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_NPR_POSTOLJE');
    _pbnode_dirty_enrich(_temp_pbnode, protobomp_superdata);
    const { created_tempkey: sklop_nprpostolje } = protobomp_manipulator.add(_protobomp, _temp_pbnode, sklop_npr);
    //
    //
    // ----- dodavanje primitivnih u sklopove
    //
    if (true) {
      //
      if (true) { // 2. Odnosi se na element P4.1 sklopa postolja rekuperatora
        const item = {
          tempkey: 1,
          pbnode_family: 'terkk$nprpostolje/B_P41',
        };
        item.identmaterijala = nprpostolje_materijal_profil; // DIRTY
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_nprpostolje);
      }
      //
      if (true) { // 3. Odnosi se na element P4.2 sklopa postolja rekuperatora
        const item = {
          tempkey: 1,
          pbnode_family: 'terkk$nprpostolje/B_P42',
        };
        item.identmaterijala = nprpostolje_materijal_profil; // DIRTY
        _pbnode_dirty_enrich(item, protobomp_superdata, true);
        const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
        protobomp_manipulator.add(_protobomp, pbnode, sklop_nprpostolje);
      }
    }
  }
  //
  //
  return {
    // _arr,
    _protobomp,
  };
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_npr_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: p,


  };
  return v_input;
};


export const derAutoCreateVirbom_terkk_npr_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_npr_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


